import variables from '../variables';
/* eslint-disable */
const MuiListItemText = {
  root: {
    fontFamily: variables.font.fontFamilySerif.join(','),
  },
};

export default MuiListItemText;
